import Test from "./Test";

export default class ColumnsFilterSmokeTest extends Test {
  constructor(api) {
    super(api, "Columns Filter Smoke Test");
  }

  async init() {
    try {
      // Fetch all workflows
      const response = await this.api.get("/workflow");
      // Prepare test cases for each workflow
      return response.map(wf => {
        let label = wf.label || wf.slug;
        return {
          name: `Workflow Test: ${label || "[Unnamed]"}`,
          slug: wf.slug,
          label: label,
          link: this.api.host.replace("/api", "") + "/workflow/" + wf.slug
        };
      });
    } catch (error) {
      throw new Error("Failed to load workflows. Error: " + error.message);
    }
  }

  async exec(test) {
    let label = test.label || test.slug;
    let baseRoute = test?.slug?.includes("__MOBILE__")
      ? "/mobile/workflow/" + test.slug.replace("__MOBILE__", "")
      : "/workflow/" + test.slug;
    // 1. Fetch workflow objects
    let route = `${baseRoute}/objects`;
    let res = await this.api.get(route, {
      limit: 1,
      fields: "all"
    });
    if (res.error) {
      return {
        success: false,
        message: `Failed to load objects for workflow ${label}. Error: ${res?.error?.data?.message}`
      };
    }

    // 2. Fetch workflow columns
    const columnsRoute = `${baseRoute}/columns`;
    const columnsRes = await this.api.get(columnsRoute);

    if (columnsRes.error) {
      return {
        success: false,
        message: `Failed to load columns for workflow ${label}. Error: ${columnsRes?.error?.data?.message}`
      };
    }

    // 3. For each column, check filter-options
    for (const col of columnsRes) {
      const filterRoute = `${baseRoute}/columns/${col.key}/filter-options`;
      const filterRes = await this.api.get(filterRoute);
      if (filterRes?.error) {
        return {
          success: false,
          message: `Column ${col.key} filter options failed to load in workflow ${label}. Error: ${filterRes?.error?.data?.message || "Unknown error"}`
        };
      }
      if (!Array.isArray(filterRes)) {
        return {
          success: false,
          message: `Column ${col.key} filter-options is not an array in workflow ${label}.`
        };
      }
      for (let item of filterRes) {
        if (typeof item == "object" && typeof item?.value == "object") {
          return {
            success: false,
            message: `Column ${col.key} filter-options has object entry in workflow ${label}.`
          };
        }
      }
    }

    return {
      success: true,
      message: `Workflow ${label} and all column filters passed successfully.`
    };
  }
}
